import { TableFilters } from '@/components/filter-bar';
import type { ParkedDeposit } from '@/services/api/parked-deposits';
import { fromSharedState, PARKED_DEPOSIT_FILTER_CONFIGS, type ParkedDepositFilters, toSharedState } from './filters';

interface ParkedDepositFiltersBarProps {
  /** Full (unfiltered) dataset — multi-choice options are derived from it */
  deposits: ParkedDeposit[];
  filters: ParkedDepositFilters;
  onFiltersChange: (filters: ParkedDepositFilters) => void;
}

// Note for whoever reads this next to migrate a similar dialog: the shared FilterEditDialog's
// "Clear" button applies immediately and closes the dialog (institutions' canonical behaviour).
// This slice's previous bespoke dialog had "Clear" reset the draft only, without applying —
// that one interaction detail changes with this migration. It is a dialog-UX difference only;
// no matching/correctness semantics changed (see filters.ts for the preserved matchMode table).
export const ParkedDepositFiltersBar = ({ deposits, filters, onFiltersChange }: ParkedDepositFiltersBarProps) => (
  <TableFilters configs={PARKED_DEPOSIT_FILTER_CONFIGS} onChange={(next) => onFiltersChange(fromSharedState(next))} rows={deposits} state={toSharedState(filters)} />
);
ParkedDepositFiltersBar.displayName = 'ParkedDepositFiltersBar';
